<template>
  <div>
    <div class="container table-actions">
      <button
          class="table-actions-button btn-green"
          @click="openModalECP"
          type="button">
        Подписать и отправить
      </button>
    </div>
    Here
    <div class="table-container-inner">
      {{ illiquidReport.id }}
      <!--      {{illiquidReport.report_id}}-->
      <table>
        <thead>
        <tr class="tr-fixed-height">
          <th class="metall-received-count" scope="col" rowspan="3">№ п/п</th>
          <th class="metall-received-count" scope="col" rowspan="2" colspan="3">Наименование ТМЦ</th>
          <th class="metall-received-count" scope="col" rowspan="2" colspan="4">Остатки ТМЗ на 01.02.2021г</th>
          <th class="metall-received-count" scope="col" rowspan="1" colspan="9">Период с 01.02.2021г. по 28.02.2021г.
          </th>
          <th class="metall-received-count" scope="col" rowspan="2" colspan="3">Остатки ТМЗ на 28.02.2021г.</th>
        </tr>
        <tr>
          <th colspan="3">Поступило ТМЦ</th>
          <th colspan="3">Реализовано/Списано</th>
          <th colspan="3">Переведено в другие категории**</th>
        </tr>
        <tr>
          <th>Код ТМЦ (SAP, 1С)</th>
          <th>Наименование ТМЦ</th>
          <th>Ед. изм.</th>
          <th>Дата поступления</th>
          <th>Кол-во</th>
          <th>Цена</th>
          <th>Сумма</th>
          <th>Кол-во</th>
          <th>Цена</th>
          <th>Сумма</th>
          <th>Кол-во</th>
          <th>Цена</th>
          <th>Сумма</th>
          <th>Кол-во</th>
          <th>Цена</th>
          <th>Сумма</th>
          <th>Кол-во</th>
          <th>Цена</th>
          <th>Сумма</th>
        </tr>

        </thead>
        <tbody v-for="request in this.illiquidReport.report_id" :key="request.id">
        <tr>
          <th>{{ request.serial }}</th>
          <th>{{ request.code_tmc }}</th>
          <th>{{ request.name_tmc }}</th>
          <th>{{ request.measure_unit }}</th>
          <th>{{ request.remains_before_tmz_delivery_date }}</th>
          <th>{{ request.remains_before_tmz_count }}</th>
          <th>{{ request.remains_before_tmz_price }}</th>
          <th>{{ request.remains_before_tmz_sum }}</th>
          <th>{{ request.come_tmc_count }}</th>
          <th>{{ request.come_tmc_price }}</th>
          <th>{{ request.come_tmc_sum }}</th>
          <th>{{ request.implemented_tmc_count }}</th>
          <th>{{ request.implemented_tmc_price }}</th>
          <th>{{ request.implemented_tmc_sum }}</th>
          <th>{{ request.transferred_tmc_count }}</th>
          <th>{{ request.transferred_tmc_price }}</th>
          <th>{{ request.transferred_tmc_sum }}</th>
          <th>{{ request.remains_after_tmz_count }}</th>
          <th>{{ request.remains_after_tmz_price }}</th>
          <th>{{ request.remains_after_tmz_sum }}</th>
        </tr>
        </tbody>
      </table>
    </div>
    <section class="auth-modal">
      <!-- Modal Content Wrapper -->
      <div id="auth-modal-content" class="auth-modal-content">
        <div class="modal-info">
          <div
              class="modal-info-inner"
              :class="{ modalInfoEcp: showModalEcp === true }"
          >
            <div v-if="showModalEcp">
              <h3>Подписать через ЭЦП</h3>
              <form
                  method="POST"
                  id="auth-form"
                  @submit.prevent="sendSignXml"
              >
                <div hidden>
                  <select id="storageSelect">
                    <option value="PKCS12" selected>PKCS12</option>
                  </select>
                </div>

                <p class="auth-moda-explanations">
                  Для успешной подписи рекомендуется <br/>
                  выбирать ключ <b>GOSTKNCA</b>
                </p>

                <textarea
                    hidden
                    id="xmlToSign"
                    name="xmlToSign"
                    v-model="this.illiquidReport.xmlToSign"
                    rows="6"
                ></textarea>
                <textarea
                    hidden
                    class="form-control"
                    id="signedXml"
                    name="signedXml"
                    rows="6"
                    readonly
                ></textarea>
                <button
                    class="auth-choose-cert"
                    type="button"
                    @click="signXmlCall"
                >
                  Выбрать сертификат
                </button>
                <button id="test" type="submit" hidden>submit</button>
              </form>
            </div>
          </div>
        </div>

        <a href="#" class="close-auth-modal" @click="closeModal">
          <!-- X close auth icon -->
          <svg
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0"
              y="0"
              viewBox="0 0 32 32"
              style="enable-background: new 0 0 32 32"
              xml:space="preserve"
              width="24"
              height="24"
          >
              <g id="icon-x-close">
                <path
                    fill="#ffffff"
                    d="M30.3448276,31.4576271 C29.9059965,31.4572473 29.4852797,31.2855701 29.1751724,30.980339 L0.485517241,2.77694915 C-0.122171278,2.13584324 -0.104240278,1.13679247 0.52607603,0.517159487 C1.15639234,-0.102473494 2.17266813,-0.120100579 2.82482759,0.477288136 L31.5144828,28.680678 C31.9872448,29.1460053 32.1285698,29.8453523 31.8726333,30.4529866 C31.6166968,31.0606209 31.0138299,31.4570487 30.3448276,31.4576271 Z"
                    id="Shape"
                ></path>
                <path
                    fill="#ffffff"
                    d="M1.65517241,31.4576271 C0.986170142,31.4570487 0.383303157,31.0606209 0.127366673,30.4529866 C-0.12856981,29.8453523 0.0127551942,29.1460053 0.485517241,28.680678 L29.1751724,0.477288136 C29.8273319,-0.120100579 30.8436077,-0.102473494 31.473924,0.517159487 C32.1042403,1.13679247 32.1221713,2.13584324 31.5144828,2.77694915 L2.82482759,30.980339 C2.51472031,31.2855701 2.09400353,31.4572473 1.65517241,31.4576271 Z"
                    id="Shape"
                ></path>
              </g>
            </svg>
        </a>
      </div>
      <!-- end modal content wrapper -->

      <!-- clickable overlay element -->
      <div class="overlay" @click="closeModal"></div>
    </section>
  </div>
</template>

<script>
import {signXml} from "@/nclayer/ncalayer";

export default {
  name: "IlliquidReportView",
  data() {
    return {
      xmlToSign: "",
      showModalEcp: false,
      illiquidReport: {}
    }
  },
  methods: {
    getIlliquidReport() {
      this.$store.dispatch("getIlliquidReport", this.$route.params.id).then((response) => {
        this.illiquidReport = response.data;
      })
    },
    sendSignXml() {
      let signedXml = document.getElementById("signedXml");
      let formData = {
        signedXml: signedXml.value,
        reportId: this.$route.params.id,
      };
      this.$store
          .dispatch("sendSignXmlTmz", formData)
          .then(() => {
            location.reload();
            this.$store.dispatch("addNotification", {
              type: "success",
              message: "Отчет подписан",
            });
          })
          .catch((error) => {
            this.closeModal();
            this.$store.dispatch("addNotification", {
              type: "error",
              message: "Отчет не подписан - " + error.response.data,
            });
          });
    },
    signXmlCall() {
      let selectedStorage = "PKCS12";
      this.xmlToSign = this.illiquidReport.xmlToSign;
      //this.xmlToSign = '';
      signXml(selectedStorage, "SIGNATURE", this.xmlToSign);
    },
    openModalECP() {
      this.showModalEcp = true;

      let body = document.body;
      body.classList.add("show-auth-modal", "noscroll");

      // Close modal if ESC key tapped
      body.addEventListener("keyup", (e) => {
        if (e.keyCode == 27) {
          this.closeModal();
        }
      });
    },
    closeModal() {
      this.showModalEcp = false;
      let body = document.body;
      body.classList.remove("show-auth-modal", "noscroll");
    },
  },
  created() {
    this.getIlliquidReport();
  }
}
</script>

<style scoped>
.table-container {
  /* overflow-x: auto; */
  padding: 0 2rem;
  min-width: 1800px;
  margin: 0 auto;
}

.table-container-inner {
  padding: .5rem;
  margin: 0 2rem;
  /* padding: 1rem 2rem; */
  /* margin-right: 2rem; */
  /* margin: 1rem 2rem; */
  overflow-x: auto;
  max-width: 100vw;
}

table {
  width: 100%;
  border-collapse: collapse;
  text-align: center;
  margin: 0 auto 2rem;
  overflow-x: auto;
  border-bottom: 1px solid black;
}

.table-naming {
  font-size: 2rem;
  font-weight: bold;
  padding: 1rem 0;
  text-align: left;
}

.table-status {
  margin-bottom: 0.5rem;
}

th,
td {
  border: 1px solid #868686;
  padding: 0 1rem;
}

.expanded {
  padding: 0 2rem;
}

.table-specs {
  background: #36429e;
  width: 100px;
  height: 100px;
  color: white;
  text-align: center;
  border-top-left-radius: 10px;
  border: none;
  font-size: 1.5rem;
  vertical-align: bottom;
}

.table-actions {
  display: flex;
  padding: 2rem 0;
  justify-content: center;
}

.table-actions-button {
  padding: 1rem 2rem;
  border: none;
  outline: none;
  border-radius: 10px;
  margin-left: 1rem;
  cursor: pointer;
  font-size: 1.1rem;
}

.btn-green {
  background: #7ad38d;
  color: white;
}

.btn-yellow {
  background: #ffbb56;
  color: white;
}

.btn-red {
  background: #e86363;
  color: white;
}

.btn-blue {
  background: #6c63e8;
  color: white;
}

/* auth Modal
-----------------------------------------*/
.auth-modal,
.auth-modal .overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 3000;
}

.auth-modal {
  overflow: hidden;
  position: fixed;
  opacity: 0;

  -webkit-transform: translate(500%, 0%);
  transform: translate(500%, 0%);

  -webkit-transition: -webkit-transform 0s linear 0s;
  transition: transform 0s linear 0s;

  /* using flexbox for vertical centering */

  /* Flexbox display */
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;

  /* Vertical alignment */
  -webkit-box-align: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;

  -webkit-transform-style: preserve-3d;
  -moz-transform-style: preserve-3d;
  transform-style: preserve-3d;
}

.auth-modal .overlay {
  z-index: 0;
  background: rgba(13, 1, 61, 0.82);
  /* overlay color */

  opacity: 0;

  -webkit-transition: opacity 0.2s ease-out 0.05s;
  transition: opacity 0.2s ease-out 0.05s;
}

.auth-modal-content {
  position: relative;
  top: auto;
  right: auto;
  bottom: auto;
  left: auto;
  z-index: 1;

  margin: 0 auto;

  overflow-y: visible;

  background: #000;

  width: calc(100% - 12em);
  height: 0;
  padding-top: calc((100% - 12em) * 0.5625);
  /* 16:9 calc */
}

/* Scaling to fit within the current Viewport size:
   When viewport aspect ratio is greater than 16:9
   work off the height instead of the width for calc */
@media (min-aspect-ratio: 16/9) {
  .auth-modal-content {
    width: 0;
    height: calc(100vh - 10em);
    padding-top: 0;
    padding-left: calc((100vh - 10em) * 1.7778);
    /* 16:9 calc */
  }
}

/* Mobile Layout Tweaks - side margins reduced */
@media (max-width: 640px) {
  .auth-modal-content {
    width: calc(100% - 1em);
    padding-top: calc((100% - 1em) * 0.5625);
    /* 16:9 calc */
  }
}

.close-auth-modal {
  display: block;
  position: absolute;
  left: 0;
  top: -40px;

  text-decoration: none;
  font-size: 20px;
  font-weight: bold;
  color: #fff;
}

.modal-info {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;

  display: flex;
  justify-content: center;
  align-items: center;

  /* background: #000; */
  /* box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.5); */
}

.modal-info-inner {
  overflow: scroll;
  background: white;
  padding: 4rem 5rem;
  width: 100%;
  height: 100%;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0px 2px 16px rgba(235, 235, 235, 1);
}

.modalInfoEcp {
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-info-inner h3 {
  font-size: 2rem;
  margin-bottom: 1rem;
}

.auth-moda-explanations {
  margin: 0 0 1rem 0;
}

.auth-choose-cert {
  padding: 1rem 2rem;
  border: none;
  outline: none;
  border-radius: 10px;
  background: #36429e;
  color: white;
  cursor: pointer;
}

/* Show modal by adding class to body */
.show-auth-modal .auth-modal {
  opacity: 1;

  transform: translate(0%, 0%);
  -webkit-transform: translate(0%, 0%);
}

.show-auth-modal .auth-modal .overlay {
  opacity: 1;
}

.show-auth-modal .auth-modal-content {
  transform: translate(0%, 0%);
  -webkit-transform: translate(0%, 0%);
}
</style>